import styled, { css } from 'styled-components';
import theme from 'src/utils/theme';
import _Section from '../Section';
import _Text from '../Text';
import _Title from '../Title';
import _Topic from '../Topic';

export const Card = styled.div(
  ({ theme }) => css`
    width: 100%;
    max-width: 570px;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: ${theme.sz.s5};

    @media (min-width: ${theme.sz.xl}) {
      margin-left: unset;
      margin-right: unset;
      padding-bottom: unset;
    }
  `,
);

export const Section = styled(_Section)(
  ({ theme }) => css`
    background-color: ${theme.co.neutral0};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    @media (min-width: 1152px) {
      flex-direction: row;
    }
  `,
);

export const SectionContent = styled(_Section.Content)(
  ({ theme }) => css`
    align-self: center;
    margin-left: unset;
    margin-right: unset;

    @media (min-width: ${theme.sz.xl}) {
      margin-left: ${theme.sz.s12};
    }
  `,
);

export const ImageWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: row;
    position: relative;
    width: 100%;
    max-width: 663px;
    aspect-ratio: 663/890;
    margin-bottom: ${theme.sz.s4};
    overflow: hidden;

    @media (min-width: 1152px) {
      margin-left: -${theme.sz.s32};
    }
  `,
);

export const Text = styled(_Text).attrs({
  $desktopStyles: css`
    margin-bottom: ${theme.sz.s8};
    line-height: 150%;
    /* or 30px */
  `,
  $mobileStyles: css`
    margin-bottom: ${theme.sz.s4};
  `,
})(() => css``);

export const Title = styled(_Title).attrs({
  $desktopStyles: css`
    margin-bottom: ${theme.sz.s8};
    ${theme.typography.heading.desktop.accent.xl}
  `,
  $mobileStyles: css`
    margin-bottom: ${theme.sz.s4};
    ${theme.typography.heading.mobile.accent.xl}
  `,
})(() => css``);

export const Topic = styled(_Topic).attrs({
  $desktopStyles: css`
    margin-bottom: ${theme.sz.s4};
  `,
  $mobileStyles: css`
    margin-bottom: ${theme.sz.s4};
  `,
})(() => css``);
